import styled from 'styled-components'
import Row from 'components/Row'
import { theme } from 'utils/style'
import Paragraph from 'components/Paragraph/Paragraph'
import Link from 'components/Link/Link'
import Icon from 'components/Icon/Icon'

export const Wrapper = styled.div`
  position: fixed;
  z-index: 30;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: rgba(0, 0, 0, 0.9);
`

export const Container = styled(Row)`
  max-width: ${theme('grid.container')}rem;
  margin: auto;
`

export const StyledParagraph = styled(Paragraph)`
  padding-bottom: ${theme('spaces.m')};
  padding-top: ${theme('spaces.m')};
  font-size: ${theme('fonts.size.s')};
  color: ${theme('colors.white')};
`

export const CloseIcon = styled(Icon)`
  margin: ${theme('spaces.m')} auto auto auto;

  svg {
    fill: ${theme('colors.white')};
  }
`

export const StyledLink = styled(Link)`
  &,
  &:hover {
    color: ${theme('colors.secondary')};
  }
`
